import { Notyf } from 'notyf';
import { INOTIFYOPTIONS } from '../config.js';
import 'notyf/notyf.min.css';

export default class appView {
  _noteContainer = document.querySelector('#ct');
  _data;

  openModal(element) {
    $(element).modal('show');
    $('#btn-n-save').hide();
    $('#btn-n-add').show();
  }

  showContentModal(title, description, element) {
    document.querySelector('.task-heading').textContent = title;
    document.querySelector('.task-text').innerHTML = description;
    $(element).modal('show');
  }

  successMessageInfo(message) {
    const notyf = new Notyf(INOTIFYOPTIONS);
    notyf.success(message);
  }

  failedMessageInfo(message) {
    const notyf = new Notyf(INOTIFYOPTIONS);
    notyf.error(message);
  }

  closeModal(element, message, info = true) {
    info ? this.successMessageInfo(message) : this.failedMessageInfo(message);
    $(element).modal('hide');
  }

  formatDate(date, newDate = false) {
    const locale = navigator.language;

    const calcDayPassed = (date1, date2) =>
      Math.round(Math.abs(date2 - date1) / (1000 * 60 * 60 * 24));

    const formatSingleDate = (dateElement, newDate = false) => {
      const dateStr = newDate ? dateElement : dateElement.textContent;
      const dayPassed = calcDayPassed(new Date(), new Date(dateStr));

      if (dayPassed === 0) return 'Today';
      if (dayPassed === 1) return 'Yesterday';
      if (dayPassed <= 7) return `${dayPassed} days ago`;

      return new Intl.DateTimeFormat(locale).format(new Date(dateStr));
    };

    if (newDate) {
      const formattedDate = formatSingleDate(date, true);
      return formattedDate;
    } else {
      const dateElements = document.querySelectorAll('.meta-time');
      if (dateElements)
        dateElements.forEach(dateElement => {
          const formattedDate = formatSingleDate(dateElement);
          dateElement.textContent = formattedDate;
        });
    }
  }

  // renderErrorMessage(message = this._errorMsg) {
  //   if (!this._parentElement) return;
  //   const markup = `
  //     <div class="col-12 empty-note">
  //       <div class="alert alert-background alert-dismissible fade show mb-4" role="alert">
  //           <strong>${message}</strong>
  //       </div>
  //     </div>
  //   `;
  //   this._parentElement.insertAdjacentHTML('afterbegin', markup);
  // }

  renderErrorMessage(message = this._errorMsg) {
    if (!this._parentElement) return;
    const markup = `
      <div class="col-12 empty-note">
        <div class="alert alert-background alert-dismissible fade show mb-4" role="alert">
            <strong>${message}</strong>
        </div>
      </div>
    `;
    const searchEl = this._parentElement.querySelector('.search');
    searchEl.insertAdjacentHTML('afterend', markup);
  }

  removeEmptyContainer() {
    const emptyNote = document.querySelector('.empty-note');
    if (!emptyNote) return;
    if (emptyNote) emptyNote.remove();
  }

  limitCharacters(inputString, limit) {
    if (inputString.length <= limit) {
      return inputString;
    } else {
      return inputString.substring(0, limit) + '...';
    }
  }

  update(data, markup, containerElement) {
    this._data = data;
    const newMarkup = markup;
    const newDOM = document.createRange().createContextualFragment(newMarkup);
    const newElement = newDOM.querySelector(this._containterItem);

    const curHTML = containerElement.innerHTML;
    const newHTML = newElement.innerHTML;

    if (curHTML !== newHTML) {
      containerElement.innerHTML = newHTML;
    }
  }

  sortDataByTimestamp(data) {
    return data.sort((a, b) => a.timestamp - b.timestamp);
  }

  // getElementsByAttribute(attributeName, attributeValue) {
  //   const selector = `[data-${attributeName}="${attributeValue}"]`;
  //   return document.querySelectorAll(selector);
  // }

  getElementsByAttribute(attributeName, attributeValue, excludedClass) {
    const selector = `[data-${attributeName}="${attributeValue}"]:not(.${excludedClass})`;
    return document.querySelectorAll(selector);
  }

  toggleMenuViews() {
    const self = this;
    this._listBtns.forEach(btn => {
      btn.addEventListener(
        'click',
        function () {
          const btnId = btn.id;

          let elementsToShow;

          if (['warning', 'danger', 'primary'].includes(btn.id)) {
            elementsToShow = self.getElementsByAttribute(
              'priority',
              btnId,
              'todo-task-trash'
            );
          } else {
            elementsToShow = document.querySelectorAll('.' + btnId);
          }

          const elementsArray = Array.from(elementsToShow);

          elementsArray.forEach(el => {
            el.classList.add('fade-in');
            el.style.display = 'block';
            setTimeout(() => {
              el.classList.remove('fade-in');
            }, 300);
          });

          const allElements = document.querySelectorAll('#ct > div');

          allElements.forEach(el => {
            if (!elementsArray.includes(el)) {
              el.style.display = 'none';
            }
          });

          this._listBtns.forEach(btn => btn.classList.remove('active'));
          btn.classList.add('active');
        }.bind(this)
      );
    });
  }

  validateInput(validationField, titleInput, descriptionInput) {
    let isValid = true;

    if (titleInput) {
      const titleInputValue = titleInput.value;

      if (titleInputValue === '') {
        validationField[0].innerHTML = 'Title Required';
        validationField[0].style.display = 'block';
        isValid = false;
      } else if (titleInputValue.length > this._titleMaxLength) {
        validationField[0].innerHTML = `Max Length is ${this._titleMaxLength.toString()} characters`;
        validationField[0].style.display = 'block';
        isValid = false;
      } else {
        validationField[0].style.display = 'none';
      }
    }

    if (descriptionInput) {
      const descriptionInputValue = this._isQuill
        ? this._quill.getText().trim()
        : descriptionInput.value;

      if (descriptionInputValue === '') {
        validationField[1].innerHTML = 'Description Required';
        validationField[1].style.display = 'block';
        isValid = false;
      } else if (descriptionInputValue.length > this._descriptionMaxLength) {
        validationField[1].innerHTML = `Max Length is ${this._descriptionMaxLength.toString()} characters`;
        validationField[1].style.display = 'block';
        isValid = false;
      } else {
        validationField[1].style.display = 'none';
      }
    }

    return isValid;
  }

  openNoteModal(element, title, description) {
    this.openModal(element);
    title = document.querySelector('#n-title');
    title.setAttribute('maxlength', this._titleMaxLength.toString());
    description = document.querySelector('#n-description');
    description.setAttribute(
      'maxlength',
      this._descriptionMaxLength.toString()
    );
  }

  _searchLists(element) {
    document
      .querySelector('.input-search')
      .addEventListener('keyup', function () {
        const searchTerm = this.value.toLowerCase();
        const todoItems = element;

        todoItems.forEach(function (item) {
          const itemText = item.textContent.toLowerCase();
          if (itemText.includes(searchTerm)) {
            item.style.display = 'block';
          } else {
            item.style.display = 'none';
          }
        });
      });
  }

  formatTime(timestamp) {
    const date = new Date(timestamp);
    const timeOptions = {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    };
    return new Intl.DateTimeFormat('en-US', timeOptions).format(date);
  }

  relativeTime(timestamp) {
    const now = new Date();
    const timeDifference = now - timestamp;
    const minutesDifference = Math.floor(timeDifference / (1000 * 60));
    const hoursDifference = Math.floor(timeDifference / (1000 * 60 * 60));

    if (minutesDifference < 1) {
      return 'Just now';
    } else if (minutesDifference < 60) {
      return `${minutesDifference} minute${
        minutesDifference > 1 ? 's' : ''
      } ago`;
    } else if (hoursDifference < 24) {
      return `${hoursDifference} hour${hoursDifference > 1 ? 's' : ''} ago`;
    } else {
      return this.formatTime(timestamp);
    }
  }
}
